exports.sharePath = {
  host: "https://jbfc.kr"
}
